<!--
    描述：菜单信息
    日期：2021/04/28
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>菜单列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="success" size="small" icon="el-icon-check"
                        v-if="roleBtns.includes('post_menu_save')" @click="saveClick()">保存
                    </el-button>
                </div>
            </div>
            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="content" style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="tree"
                                 :height="treeObj.tableH"
                                 :data="treeObj.data"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"
                                 @node-click="nodeClick"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import {selectTree} from 'api/system/menu.js'
import {saveOrUpdateRoleMenu,getCheckedMenu} from 'api/system/sysGroupRoleMenu.js'
import { selectMenusById,savePositionAndMenu } from 'api/system/sysPosition.js'
export default {
    name : '',
    components: {

    },
    data() {
        return {
            //树默认选中信息
            treeDefaultCheckedKey: [],

            treeObj: {
                loading: false,
                tableH: 200,
                data: [],

                dataList : [],

                oriData: [],
                dataByRoleData: [],
            },

            defaultProps: {
                children: 'children',
                label: 'sname'
            },

            groupId : '',
            roleId : '',
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.treeObj.tableH = this.$refs.content.offsetHeight;
            }, 100)
        })
    },
    computed: {
        ...mapState('app', {clientSize: state => state.clientSize}),
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    },
    watch: {
        clientSize(val) {
            this.treeObj.tableH = this.$refs.content.offsetHeight;
        }
    },
    created() {
        //获取菜单信息
        this.getMenuTreeTableData();
    },
    methods: {
        init(obj){
            this.treeDefaultCheckedKey = []
            this.treeObj.data = []
            this.treeObj.dataList = []

            this.postId = obj.postId
            if(obj.postId == '') return

            //获取权限菜单数据
            //this.getCheckedMenu()

            this.selectMenusById()
        },
        selectMenusById(){
            let that = this
            let param = {
                id : this.postId
            }
            selectMenusById(param).then(res => {
                if (res.operationCode == 1) {
                    that.treeObj.oriData = res.data;
                    that.treeObj.data = that.treeObj.oriData.concat()
                    that.treeObj.dataList = that.$utils.toTreeArray(res.data)
                    this.treeDefaultCheckedKey = that.treeObj.dataList.filter(item=> item.isChecked == true).map(item=> {return item.id})
                    console.log(this.treeDefaultCheckedKey)
                }
            });
        },

        //获取菜单信息
        getMenuTreeTableData() {
            let that = this
            let param = {}
            selectTree(param).then(res => {
                if (res.operationCode == 1) {
                    that.treeObj.oriData = res.data;
                    that.treeObj.data = that.treeObj.oriData.concat()
                }
            });

        },
        getCheckedMenu(){
            let that = this
            let param = {
                groupId : this.groupId,
                roleId: that.roleId,
            }
            getCheckedMenu(param).then(res=>{
                if (res.operationCode == 1) {
                    this.treeDefaultCheckedKey = res.data
                }
            })
        },
        saveClick(){
            let that = this
            if (that.postId == '') {
                that.$message({message: '请选择岗位信息', type: 'warning'});
                return;
            }

            let menuIdsSelection = [];
            let checkSelection = this.$refs.tree.getCheckedKeys().concat()
            checkSelection = checkSelection.map(nodeId=>{
                let temp = that.treeObj.dataList.find(v=> v.id == nodeId)
                let obj = {
                    "id": temp.id,
                    "sname": temp.sname,
                    "isChecked": true
                }
                return obj
            })
            let param = {
                positionId : that.postId,
                menuList: checkSelection
            }
            savePositionAndMenu(param).then(res => {
                if (res.operationCode == 1) {
                    that.$message({message: '保存成功', type: 'success'});
                }
            });
        },
        //节点点击
        nodeClick(obj) {
            this.$emit('row-click', obj)
        },
    }
}
</script>
<style lang="less">

</style>